import toDate from '../toDate/index.js'

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Number} the hours
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
export default function getHours (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions)
  var hours = date.getHours()
  return hours
}



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/esm/getHours/index.js
// module id = 908
// module chunks = 0